import { MovieOpenRemoveOutlineIcon } from './MovieOpenRemoveOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 320C9DCC-5845-46F6-B3E6-412D22B8BF47
 * name movie-open-remove-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-remove-outline.svg
 * tags
 * - Video / Movie 
 */
export const SlateOpenRemoveOutlineIcon = MovieOpenRemoveOutlineIcon;
export default SlateOpenRemoveOutlineIcon